import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import moment from 'moment';
import TableLoader from 'components/TableLoader';

interface Row {
  id: number;
  doc: string;
  apellido: string;
  nombre: string;
  email: string;
  validated: boolean;
  created_at: string;
}

interface Props {
  items: Row[];
  isLoading: boolean;
  currentOrder: {
    field: string;
    dir: number;
  };
  changeOrder: (field: string, dir: number) => void;
  id?: string;
}

export default function NoMatriculatesTable(props: Props) {
  const { items, isLoading, currentOrder, changeOrder, id } = props;

  const getIconClassBySorted = (field: string) => {
    if (currentOrder.field === field) {
      return currentOrder.dir === -1 ? 'fa fa-caret-down' : 'fa fa-caret-up';
    }

    return 'fas fa-sort';
  };

  const setNewOrder = (field: string) => {
    if (currentOrder && currentOrder.field === field) {
      changeOrder(currentOrder.field, currentOrder.dir === 1 ? -1 : 1);
    } else {
      changeOrder(field, 1);
    }
  };

  const columns = [
    {
      name: 'doc',
      label: 'DNI',
      sort: true,
      value: (row: Row) => row.doc,
    },
    {
      name: 'apellido',
      label: 'Apellido',
      sort: true,
      value: (row: Row) => row.apellido,
    },
    {
      name: 'nombre',
      label: 'Nombre',
      sort: true,
      value: (row: Row) => row.nombre,
    },
    {
      name: 'email',
      label: 'Email',
      sort: true,
      value: (row: Row) => row.email,
    },
    {
      name: 'validated',
      label: 'Validado',
      sort: true,
      value: (row: Row) => (row.validated ? 'Sí' : 'No'),
    },
    {
      name: 'created_at',
      label: 'Fecha de Registro',
      sort: true,
      value: (row: Row) =>
        row.created_at ? moment(row.created_at).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      name: 'actions',
      label: 'Acciones',
      sort: false,
      value: (row: Row) => (
        <Link
          to={`/admin/no-matriculates/${row.id}/edit`}
          className="btn btn-round btn-primary btn-sm"
        >
          <i className="fa fa-edit"></i>
        </Link>
      ),
    },
  ];

  return (
    <Table className="align-items-center table-flush" responsive id={id}>
      <thead className="thead-light">
        <tr>
          {columns.map(column => {
            if (!column.sort) {
              return (
                <th key={column.name} scope="col">
                  {column.label}
                </th>
              );
            }
            return (
              <th
                key={column.name}
                scope="col"
                className="clickable"
                onClick={() => setNewOrder(column.name)}
              >
                {column.label}
                <i className={getIconClassBySorted(column.name)}></i>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {!isLoading ? (
          Array.isArray(items) && items.length ? (
            items.map(row => (
              <tr key={row.id}>
                {columns.map(column => (
                  <td key={column.name}>{column.value(row)}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length + 1} className="text-center">
                <span>No se encontraron no matriculados</span>
              </td>
            </tr>
          )
        ) : (
          <tr>
            <td colSpan={columns.length + 1} className="text-center">
              <TableLoader />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
